<script setup lang="ts">
const emit = defineEmits(["remove"])
const backgroundColor = defineModel<string>("nearColor")
const colorPicker = useTemplateRef("colorPicker")

const onClickColor = () => {
  colorPicker.value!.click()
}

const onHideColor = () => {
}

const onRemoveColor = () => {
  emit("remove")
}

onMounted(async () => {
  await nextTick()
  colorPicker.value?.click()
})
</script>

<template>
  <div class="color-picker-container">
    <div class="color-picker-description">
      Similar to
    </div>
    <div
      class="color-picker-button"
      @click="onClickColor()"
    >
      <div class="color-picker-view" :style="{ backgroundColor }" />
      <div>
        {{ backgroundColor?.replace("#", "") }}
      </div>
    </div>
    <div class="color-picker-close" @click="onRemoveColor()">
      <icon-action type="cross" size="2xs" />
    </div>
    <input
      ref="colorPicker"
      v-model="backgroundColor"
      type="color"
      class="hidden-color-picker"
      @change="onHideColor()"
    >
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.color-picker-container
  @apply flex flex-none items-center gap-[#{$menu-search-gap-item-facet}] relative
  @apply h-[24px]
  @apply rounded-[#{$menu-br-item}] overflow-hidden
  @apply t-menu-sm

.color-picker-description
  @apply flex flex-none items-center
  @apply h-full px-2

.color-picker-close
  @apply flex flex-none items-center
  @apply h-full px-1

.color-picker-description
  @apply bg-$global-orange-accent
  @apply text-$global-orange-primary

.color-picker-close
  @apply bg-$global-orange-accent
  @apply text-$global-orange-primary
  @apply cursor-pointer
  &:hover
    @apply bg-$global-orange-secondary

.color-picker-button
  @apply flex-none flex items-center gap-[#{$menu-search-gap-item-facet-section}]
  @apply cursor-pointer
  @apply h-full px-2 bg-$global-orange-accent
  @apply text-$global-orange-primary
  @apply font-mono uppercase
  &:hover
    @apply bg-$global-orange-secondary

.color-picker-view
  @apply w-3 h-3 aspect-square rounded-full

.hidden-color-picker
  @apply w-0 h-0 absolute -bottom-2 left-0
</style>
